import { FieldAttributes, useField } from 'formik'
import { Form } from 'react-bootstrap'
import InputErrorWrapper from '../InputErrorWrapper'
import styles from './NumberInput.module.scss'

// FEATURE: allow number input only
// eslint-disable-next-line
const NumberInput: React.FC<FieldAttributes<any>> = ({ touched, ...props }): JSX.Element => {
    const [field, meta] = useField(props)

    return (
        <InputErrorWrapper meta={meta} testId={props.name}>
            <Form.Control
                type="number"
                {...field}
                {...props}
                value={field.value || ''}
                className={[props.className, styles.field].join(' ')}
                isInvalid={!!meta.error && meta.touched}
                isValid={!meta.error && meta.touched}
                data-testid={`formNumberInput_${props.name}`}
            />
        </InputErrorWrapper>
    )
}

export default NumberInput
